
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/sme-website-development",
      function () {
        return require("private-next-pages/services/sme-website-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/sme-website-development"])
      });
    }
  